import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useNotifier } from '@provider/notifier';
import { useUserIdentityState } from '@provider/user-identity';
import { getAllRevisionsQuery } from './query.get-all.js';
import { updateRevisionRequest } from './request.update.js';

function useUpdateRevisionMutation() {
  const client = useQueryClient();
  const notifier = useNotifier();
  const user = useUserIdentityState(state => state.user);
  return useMutation(updateRevisionMutation(client, notifier, user));
}
const updateRevisionMutation = (client, notifier, user) => {
  return {
    mutationKey: ["course-revision/update", user?.id],
    mutationFn: async revision => {
      await updateRevisionRequest(user, revision);
      return undefined;
    },
    onMutate: async input => {
      const prev = client.getQueryData(getAllRevisionsQuery.queryKey({
        user,
        courseId: input.courseId
      }));
      client.setQueryData(getAllRevisionsQuery.queryKey({
        user,
        courseId: input.courseId
      }), prev => prev?.map(it => it.__clientId === input.__clientId ? input : it));
      await client.cancelQueries({
        queryKey: getAllRevisionsQuery.queryKey({
          user,
          courseId: input.courseId
        })
      });
      return {
        optimistic: input,
        prev
      };
    },
    onSuccess: () => {
      notifier.notify({
        id: "course-revisions.update",
        type: "success",
        body: "Versionen er blevet gemt."
      });
    },
    onError: (error, input, context) => {
      notifier.notify({
        id: "course-revisions.update.error",
        type: "error",
        body: "Versionen kunne ikke gemmes. Prøv igen om lidt."
      });
      client.setQueryData(getAllRevisionsQuery.queryKey({
        user,
        courseId: input.courseId
      }), prev => prev?.map(it => it.__clientId === context?.prev?.__clientId ? context.prev : it));
    }
  };
};

export { useUpdateRevisionMutation };
//# sourceMappingURL=mutation.update.js.map
